import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppState, AppActions } from "./types";

const loadStateFromLocalStorage = (): AppState => {
    try {
        const serializedState = localStorage.getItem("appState");
        return serializedState
            ? JSON.parse(serializedState)
            : { financialYear: "", entityId: "" };
    } catch (err) {
        return { financialYear: "", entityId: "" };
    }
};

const saveStateToLocalStorage = (state: AppState) => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem("appState", serializedState);
    } catch (err) {
        console.error("Could not save state", err);
    }
};

const initialState: AppState = loadStateFromLocalStorage();

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        setFinancialYear: (state, action: PayloadAction<string>) => {
            state.financialYear = action.payload;
            saveStateToLocalStorage(state);
        },
        setEntityId: (state, action: PayloadAction<string>) => {
            state.entityId = action.payload;
            saveStateToLocalStorage(state);
        },
    },
});

export const { setFinancialYear, setEntityId } = appSlice.actions;
export const selectFinancialYear = (state: any) =>
    state.entity.financialYear;
export const selectEntityId = (state: any) => state.entity.entityId;

const dateEntityReducer = appSlice.reducer;
export default dateEntityReducer;
